import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import TextChartTitle from '@components/text/TextChartTitle'
import { Flex, Progress, Table } from '@mantine/core'
import TableHeaderColumn from '@components/table/template/TableHeaderColumn'
import { IResponseOptVendorEvaluationRanking } from '@interfaces/api/IDashboard'
import { Money, Num } from '@utils/utils'
import _ from 'lodash'

const VendorEvaluationRanking = ({ title, data }: { title: string; data: IResponseOptVendorEvaluationRanking }) => {
  const maxBudgetLecturer = _.maxBy(data, (l) => parseFloat(l.total_budget))!
  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Table pos={'relative'}>
        <thead>
          <tr>
            <TableHeaderColumn label={'อันดับ'} width={'0%'} />
            <TableHeaderColumn label={'ผู้ค้า'} width={'10%'} />
            <TableHeaderColumn label={'การประสานงาน'} width={'5%'} />
            <TableHeaderColumn label={'การซื้อขาย/บริการ\n'} width={'5%'} />
            <TableHeaderColumn label={'การบริการหลังการขาย\n'} width={'5%'} />
            <TableHeaderColumn label={'ค่าเฉลี่ยความพึงพอใจ (จำนวนโครงการ)'} width={'10%'} />
            <TableHeaderColumn label={'ผลประเมิน'} width={'5%'} />
            <TableHeaderColumn label={'จำนวนโครงการ'} width={'5%'} />
            <TableHeaderColumn label={'มูลค่าโครงการ'} width={'7%'} />
            <TableHeaderColumn label={''} width={'40%'} />
          </tr>
        </thead>
        <tbody>
          {data.map((p) => (
            <tr key={p.rank_no}>
              <td>{p.rank_no}</td>
              <td>{p.vendor_name}</td>
              <td>{p.avg_vendor_evaluation_factor_1 ? <Flex gap="xs">{p.avg_vendor_evaluation_factor_1}</Flex> : 'ไม่มีข้อมูล'}</td>
              <td>{p.avg_vendor_evaluation_factor_2 ? <Flex gap="xs">{p.avg_vendor_evaluation_factor_2}</Flex> : 'ไม่มีข้อมูล'}</td>
              <td>{p.avg_vendor_evaluation_factor_3 ? <Flex gap="xs">{p.avg_vendor_evaluation_factor_3}</Flex> : 'ไม่มีข้อมูล'}</td>
              <td>
                <Flex gap="xs">
                  {p.avg_vendor_evaluation_result ? <Flex gap="xs">{p.avg_vendor_evaluation_result}</Flex> : 'ไม่มีข้อมูล'} (
                  {p.total_evaluation_projects} โครงการ)
                </Flex>
              </td>
              <td>{p.vendor_evaluation_grade ? <Flex gap="xs">{p.vendor_evaluation_grade}</Flex> : 'ไม่มีข้อมูล'}</td>
              <td>{Num(p.total_projects)}</td>
              <td>{Money(p.total_budget)}</td>
              <td>
                <Progress
                  w="100%"
                  size="xl"
                  sections={[
                    {
                      value: parseFloat(p.total_budget) / (parseFloat(maxBudgetLecturer.total_budget) / 100),
                      color: 'blue',
                    },
                  ]}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </ChartFlexSection>
  )
}

export default VendorEvaluationRanking
